import { Order } from 'commons/utils/types/dashboard-response-dto';

export type BalanceState = {
  orders?: Order[];
  amount?: number;
  contentDeclaration?: boolean;
};

export type Action =
  | {
      type: 'SET_AMOUNT';
      payload: number;
    }
  | {
      type: 'SET_ORDERS';
      payload: Order[];
    }
  | {
      type: 'RESET_AMOUNT';
    }
  | {
      type: 'SET_CONTENT_DECLARATION';
      payload: boolean;
    };

const initialState: BalanceState = {
  amount: 0,
  orders: [],
  contentDeclaration: false
};

const balanceReducer = (state: BalanceState, action: Action): BalanceState => {
  switch (action.type) {
    case 'SET_AMOUNT':
      return { ...state, amount: action.payload };

    case 'SET_ORDERS':
      return { ...state, orders: action.payload };

    case 'RESET_AMOUNT':
      return { ...state, amount: 0 };

    case 'SET_CONTENT_DECLARATION':
      return { ...state, contentDeclaration: action.payload };

    default:
      return state;
  }
};

export { initialState, balanceReducer };
